<div [fxLayout]="horizontaly ? 'row' : 'column'" fxLayoutAlign="center center">
    <button mat-icon-button *ngFor="let button of menuIcons" (click)="buttonClicked.emit(button.buttonAction)" [disabled]="button.disabled" color="sims">
        <mat-icon class="mr-1" svgIcon="{{button.iconName}}"></mat-icon>
    </button>
</div>